export const getBusinessDocumentTitle = (name: string): string => {
  let title = "-";
  if (name === "cac") {
    title = "Certificate of Incorporation";
  } else if (name === "particulars-of-directors") {
    title = "Status Report / CO7";
  } else if (name === "utility-bill" || name === "bank-statement") {
    title = "Proof of Address";
  }
  return title;
};

export const getKycLevel = (
  bvnValidated: boolean,
  isFinalResult: boolean | null,
  kycAddressVerificationFile: string | null
): string => {
  const VALID_SCORE = 1;
  const overallScore = 3;
  let totalScore = 0;

  if (bvnValidated) {
    totalScore += VALID_SCORE;
  }
  if (isFinalResult) {
    totalScore += VALID_SCORE;
  }
  if (kycAddressVerificationFile) {
    totalScore += VALID_SCORE;
  }

  return `${totalScore}/${overallScore}`;
};
